export const VALIDATE_EMAIL = 'EMAIL_INPUT_CHANGE'
export const VALIDATE_FIRST_NAME = 'FIRSTNAME_INPUT_CHANGE'
export const VALIDATE_LAST_NAME = 'LASTNAME_INPUT_CHANGE'
export const VALIDATE_PASSWORD = 'PASSWORD_INPUT_CHANGE'
export const VALIDATE_PASSWORD_CONFIRMATION = 'PASSWORD_CONFIRMATION_INPUT_CHANGE'

export const SEND_SIGN_UP_REQUEST = 'SEND_SIGN_UP_REQUEST'
export const RECEIVE_SIGN_UP_RESPONSE = 'RECEIVE_SIGN_UP_RESPONSE'
export const RECEIVE_SIGN_UP_ERROR = 'RECEIVE_SIGN_UP_ERROR'

export const CLEAR_SIGN_UP_ERROR = 'CLEAR_SIGN_UP_ERROR'

export const validateEmail = (newInput) => ({
  type: VALIDATE_EMAIL,
  newInput
})

export const validateFirstName = (newInput) => ({
  type: VALIDATE_FIRST_NAME,
  newInput
})

export const validateLastName = (newInput) => ({
  type: VALIDATE_LAST_NAME,
  newInput
})

export const validatePassword = (newInput) => ({
  type: VALIDATE_PASSWORD,
  newInput
})

export const validatePasswordConfirmation = (newInput) => ({
  type: VALIDATE_PASSWORD_CONFIRMATION,
  newInput
})

const sendSignUpRequest = () => ({ type: SEND_SIGN_UP_REQUEST })

const receiveSignUpResponse = (ok) => ({
  type: RECEIVE_SIGN_UP_RESPONSE,
  ok
})

// action to handle fetch error, first it will add error to store,
// then remove it after timeout to enable another attempt
const handleSignUpFetchError = () => (dispatch) => {
  dispatch({ type: RECEIVE_SIGN_UP_ERROR })
  setTimeout(() => dispatch({ type: CLEAR_SIGN_UP_ERROR }), 2500)
}

export const fetchSignUp = (inputValues) => (dispatch) => {
  dispatch(sendSignUpRequest())

  inputValues.URL = window.location.href

  return fetch(
    process.env.REACT_APP_BASE_URL + '/account/register',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify(inputValues)
    }
  ).then(
    response => {
      if (response.ok) {
        dispatch(receiveSignUpResponse(response.ok))
      } else {
        dispatch(handleSignUpFetchError())
      }
    },
    error => dispatch(handleSignUpFetchError(error)) // handling no network error
  )
}
